import * as React from "react"
import { ChevronDown } from "lucide-react"
import { cn } from "../../lib/utils.ts"

export interface SelectOption {
  value: string
  label: string
}

interface YearSelectProps {
  value: string
  onValueChange: (value: string) => void
  options: SelectOption[]
  className?: string
}

export function YearSelect({ value, onValueChange, options, className }: YearSelectProps) {
  return (
    <div className="relative">
      <select
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        className={cn(
          "h-7 w-full rounded-md border border-gray-200",
          "bg-white px-2 py-0.5 text-sm text-gray-700",
          "focus:outline-none focus:ring-2 focus:ring-purple-200 focus:border-purple-300",
          "hover:border-purple-300 transition-colors duration-200",
          "appearance-none cursor-pointer pr-6",
          className
        )}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <ChevronDown className="absolute right-1.5 top-1.5 h-4 w-4 text-gray-400 pointer-events-none" />
    </div>
  )
} 